import { darkGrey, primaryColor } from '~/colors'

export default {
    container: {
        width: 275
    },
    accordionTitle: {
        display: 'inline'
    },
    productLink: {
        marginBottom: 12,
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    link: {
        textDecoration: 'none',
        fontFamily: 'Lato, Arial, Helvetica, sans-serif',
        fontSize: 14,
        color: darkGrey
    },
    linkActive: {
        color: primaryColor
    },
    itemDecoration: {
        borderRadius: '50%',
        height: 5,
        width: 5,
        backgroundColor: primaryColor,
        display: 'inline-block',
        marginRight: 6
    }
}



// WEBPACK FOOTER //
// ./src/views/Products/ProductSelector/styles.js